import React from 'react'
import type { ChangeEventHandler } from 'react'

// import '@daypicker/react/style.css'

interface DatePickerProps {
  id: string
  date?: string
  label: string
  name?: string
  onChange: ChangeEventHandler<HTMLInputElement, HTMLInputElement>
  placeholder?: string
}

const DatePicker = ({
  id,
  date,
  label,
  name,
  onChange,
  placeholder,
}: DatePickerProps) => {
  return (
    <div style={{ position: 'relative' }}>
      <label htmlFor={id}>{label}</label>
      <input
        name={name}
        id={date}
        type='date'
        value={date}
        placeholder='MM/dd/yyyy'
        onChange={onChange}
      />
    </div>
  )
}

export default DatePicker
